import React from 'react';
import { QrScanChecklistModal } from '@/common/QrScan';

/**
 * HVAC Filter-specific scan-against-target-list modal.
 *
 * Props match the original implementation so the caller in HvacFilterAllocation
 * needs no changes. All scanning UX is delegated to QrScanChecklistModal.
 */
const HvacScanModal = ({
  visible,
  onCancel,
  onConfirm,
  targetLabels = [],
  title = 'Scan HVAC Filters',
  confirmButtonText = 'Confirm',
  loading = false,
  // eslint-disable-next-line no-unused-vars
  scannerId
}) => (
  <QrScanChecklistModal
    visible={visible}
    onCancel={onCancel}
    onConfirm={onConfirm}
    targetLabels={targetLabels}
    title={title}
    confirmButtonText={confirmButtonText}
    loading={loading}
    noun={{ singular: 'filter', plural: 'filters' }}
    manualPlaceholder="Type HVAC label manually (e.g. HF-123)"
  />
);

export default HvacScanModal;
